import React, { FC, PropsWithChildren } from "react";
import classNames from "classnames";

import "./index.scss";

export type BadgeProps = PropsWithChildren<{
  background?: "lightgray" | "lightblue";
  weight?: "normal" | "bold";
  size?: "small" | "medium" | "large";
  rounded?: "none" | "small" | "medium" | "large";
}>;

export const Badge: FC<BadgeProps> = ({ children, background, weight, size, rounded }) => {
  return (
    <div
      className={classNames("badge", {
        [`badge-${background}`]: background,
        [`badge-${weight}`]: weight,
        [`badge-${size}`]: size,
        [`badge-${size}`]: size,
        [`badge-rounded-${rounded}`]: rounded,
      })}
    >
      {children}
    </div>
  );
};
